export default {
  noMatchesFound: 'Ziel- und Quelldaten haben keine Überlappung. Daher is keine migration möglich.',
};
